import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { AdminPoolsCollection } from './admin-pools.types';

export function adminPoolsBackend(): Backend<AdminPoolsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/admin/pools',
      params: {
        pools: ids,
        names: getQueryParamValue(query, 'name'),
        is_talent_network: getQueryParamValue(query, 'isTalentNetwork')[0],
        // We want to include all test pools for now.
        // This is because we don't have any specific logic around test pools as of yet.
        // Once we have a better picture of what that should be, then we may update this.
        ignore_test: false,
      },
    }),
    push: (authUid, pool) => ({
      endpoint: 'users/0.1/admin/pools/',
      payload: {
        name: pool.name,
        display_name: pool.displayName,
        is_talent_network: pool.isTalentNetwork,
        is_test_pool: pool.isTestPool,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
